var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v(" 威趣科技(深圳)有限公司-CDN ")])}
var staticRenderFns = []

export { render, staticRenderFns }